import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getChannelMessageList } from '../../../api/messenger';

import { findOpenedConversations } from '../../../components/Messenger/utils/findNewConversations';
import { normalizeChats } from '../../../components/Messenger/utils/normolizeChats';

import { REQUEST } from '../../../constants/request';

export const fetchChannelMessageList = createAsyncThunk(
  'messenger/fetchChannelMessageList',
  async (args, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });

    try {
      const response = await getChannelMessageList(args, {
        cancelToken: source.token,
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
  {
    condition: (arg, { getState }) => {
      const currentLoading =
        getState().messenger.currentLoadings?.messageList || REQUEST.idle;

      return currentLoading !== REQUEST.pending;
    },
  },
);

export const fetchChannelMessageListExtraReducers = builder => {
  builder
    .addCase(fetchChannelMessageList.pending, (state, { meta }) => {
      state.currentLoadings.messageList = REQUEST.pending;
      state.currentRequestIds.messageList = meta.requestId;
    })
    .addCase(fetchChannelMessageList.fulfilled, (state, action) => {
      const { byId, allIds, conversations } = normalizeChats(
        state,
        action.payload,
      );
      const openedConversations = findOpenedConversations(
        state,
        action.payload,
      );
      state.conversations = {
        ...state.conversations,
        [action.meta.arg]: [...openedConversations, ...conversations],
      };
      state.chats.byId = byId;
      state.chats.allIds = allIds;
      state.currentLoadings.messageList = REQUEST.idle;
      state.currentRequestIds.messageList = undefined;
    })
    .addCase(fetchChannelMessageList.rejected, (state, { payload }) => {
      state.currentLoadings.messageList = REQUEST.idle;
      state.currentRequestIds.messageList = undefined;
      state.currentErrors.messageList = payload;
    });
};
